module.exports = __webpack_public_path__ + "js/legacy/ripples.worklet.24c18ce6.js";